// import HomepageLayout from '@/components/layout/homepage-layout';
// import LandingPage from '@/pages/landing';
// import CompanyHomepageV1 from '@/pages/company-homepage/v1';
// import NotFound from '@/pages/not-found';
import {
  Suspense,
  lazy,
  useEffect,
  useState,
  ComponentType,
  ReactNode
} from 'react';
import { Navigate, useRoutes, RouteObject } from 'react-router-dom';
// import CompanyHomepageV1StandaloneLayout from '@/components/layout/company-homepage-v1-standalone-layout';
import { fetchRoutesFromApi } from './routesApi';
import { layoutsMap } from '@/layouts/layoutsMap';
import { pagesMap } from '@/pages/pagesMap';

// const DashboardLayout = lazy(() => import('@/components/layout/dashboard-layout'));
// const SignInPage = lazy(() => import('@/pages/auth/signin'));
// const CreateAccountPage = lazy(() => import('@/pages/auth/create-account'));
// const DashboardPage = lazy(() => import('@/pages/backoffice/dashboard'));
// const StudentPage = lazy(() => import('@/pages/backoffice/students'));
// const StudentDetailPage = lazy(() => import('@/pages/backoffice/students/StudentDetailPage'));

// ----------------------------------------------------------------------
import ProtectedRoute from './ProtectedRoute'; // ← upewnij się, że import jest prawidłowy
import { DefaultLoader } from '@/components/hugin/custom/Loader/v1';

// Wrapper do komponentu lazy
function lazyWrap(
  importer: () => Promise<{ default: ComponentType<any> }>
): ReactNode {
  const Component = lazy(importer);

  return (
    <Suspense fallback={<DefaultLoader />}>
      <Component />
    </Suspense>
  );
}

function mapRoutesFromApi(apiRoutes: any[]): RouteObject[] {
  return apiRoutes.map((route) => {
    const Layout = layoutsMap[route.layout];
    const isProtected = route.element === 'ProtectedRoute';
    const requiredPermission = route.requiredPermission;

    const children = route.children.map((child: any) => ({
      index: child.index,
      path: child.path ?? undefined,
      element: resolveElement(child.element)
    }));

    let innerElement = Layout ? lazyWrap(Layout) : <div>Nieznany layout</div>;

    if (isProtected) {
      innerElement = (
        <ProtectedRoute requiredPermission={requiredPermission}>
          {innerElement}
        </ProtectedRoute>
      );
    }

    return {
      path: route.path,
      element: innerElement,
      children
    };
  });
}

function resolveElement(name: string): ReactNode {
  if (name === 'Redirect404') {
    return <Navigate to="/404" replace />;
  }

  const importer = pagesMap[name];

  if (!importer || typeof importer !== 'function') {
    return <div>Nieznana strona: {name}</div>;
  }

  return lazyWrap(importer);
}

export default function AppRouter() {
  const [routesData, setRoutesData] = useState<RouteObject[]>([]);
  useEffect(() => {
    fetchRoutesFromApi().then((data) => setRoutesData(mapRoutesFromApi(data)));
  }, []);

  return useRoutes(routesData);
}
